import UploadVideoButton from 'lib/components/admin/UploadVideoButton/UploadVideoButton'
import ControlButton from 'pages/Home/admin/ControlButton/ControlButton'
import RecordedWebinarType from 'pages/Home/RecordedWebinarType'
import Series from 'pages/Home/Series'
import React, { useState } from 'react'

import AddRecordedWebinarDialog from './AddRecordedWebinarDialog'
import DeleteRecordedWebinarDialog from './DeleteRecordedWebinarDialog'

export interface RecordedWebinarAdminControlsProps {
  recordedWebinar: RecordedWebinarType
  series: Series[]
}

export default function RecordedWebinarAdminControls(props: RecordedWebinarAdminControlsProps) {
  const { recordedWebinar, series } = props
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false)

  const openDeleteDialog = () => setIsDeleteDialogOpen(true)
  const closeDeleteDialog = () => setIsDeleteDialogOpen(false)
  const openEditDialog = () => setIsEditDialogOpen(true)
  const closeEditDialog = () => setIsEditDialogOpen(false)

  return (
    <div>
      <UploadVideoButton
        recordedWebinarId={recordedWebinar.id}
        videoUploadId={recordedWebinar.video && recordedWebinar.video.id}
        style={{ left: '0', top: '10px' }}
      />
      <ControlButton variant="edit" onClick={openEditDialog} style={{ left: '35px', top: '10px' }} />
      <ControlButton variant="delete" onClick={openDeleteDialog} style={{ left: '70px', top: '10px' }} />
      {isDeleteDialogOpen && (
        <DeleteRecordedWebinarDialog onRequestClose={closeDeleteDialog} recordedWebinar={recordedWebinar} />
      )}
      {isEditDialogOpen && (
        <AddRecordedWebinarDialog
          onRequestClose={closeEditDialog}
          initialRecordedWebinar={recordedWebinar}
          series={series}
        />
      )}
    </div>
  )
}
